import { render, staticRenderFns } from "./account-info.vue?vue&type=template&id=50384953&scoped=true"
import script from "./account-info.vue?vue&type=script&lang=js"
export * from "./account-info.vue?vue&type=script&lang=js"
import style0 from "./account-info.vue?vue&type=style&index=0&id=50384953&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50384953",
  null
  
)

export default component.exports